// extracted by mini-css-extract-plugin
export default {"menuButton":"MenuButton_menuButton__JljIK","underline":"MenuButton_underline__+M52y","active":"MenuButton_active__DkuPy"};